import { StyledCloseIcon, type CloseIconVariant } from './CloseIcon.styles';

type CloseIconProps = {
  variant: CloseIconVariant;
  isDarkMode?: boolean;
};

const CloseIcon = ({ isDarkMode, variant }: CloseIconProps) => (
  <StyledCloseIcon variant={variant} className={isDarkMode ? 'dark' : ''}>
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none">
      <g clipPath="url(#a)">
        <path d="M9.9.567 9.427.093a.33.33 0 0 0-.474 0l-3.96 3.96L1.04.1a.33.33 0 0 0-.473 0L.1.567a.33.33 0 0 0 0 .473L4.06 5 .1 8.96a.33.33 0 0 0 0 .473l.473.474a.33.33 0 0 0 .474 0l3.96-3.96 3.96 3.96a.33.33 0 0 0 .473 0l.473-.474a.33.33 0 0 0 0-.473L5.953 5 9.9 1.04a.33.33 0 0 0 0-.473Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M0 0h10v10H0z" />
        </clipPath>
      </defs>
    </svg>
  </StyledCloseIcon>
);

export default CloseIcon;
